const menuOptions =  {
    perfiles: 20,
    usuarios: 30,
    proveedores:30,
    eliminaOC: 1100
}

export default menuOptions;
